/*
 * 写真リスト（カート）用
 */
$(function () {

  /*
   * リスト（カート）に追加
   */
  $(document).on("click", ".add-photo-cart", function (event) {
    event.preventDefault();
    // イベントオブジェクト
    var buttonCart = $(this);
    // token
    let token = $("meta[name=csrf-token]").attr("content");
    // ID取得
    let photoId = $(this).data("id");
    // フォーム作成
    let form = new FormData();
    form.append("_token", token);
    form.append("photo", photoId);

    console.log('_token = ', token);
    console.log('photo = ', photoId);

    // Ajax(POST)
    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      }
    });
    // type: 'POST',
    $.ajax({
      url: '/business/photo/' + photoId + '/cart/add',
      type: 'GET',
      data: form,
      processData: false,
      contentType: false,
    })
      .done(function (data) {
        // OK
        if (data) {
          // 成功
          buttonCart.html("リストに追加済み");
          buttonCart.addClass("remove-photo-cart");
          buttonCart.removeClass("add-photo-cart");
        } else {
          // 失敗
          console.log("リストの追加に失敗しました。");
          return;
        }
      })
      .fail(function (data) {
        // エラー
        console.log(data);
        return;
      });
  });

  /*
   * リスト（カート）から削除
   */
  $(document).on("click", ".remove-photo-cart", function (event) {
    event.preventDefault();
    // イベントオブジェクト
    var buttonCart = $(this);
    // token
    let token = $("meta[name=csrf-token]").attr("content");
    // ID取得
    let photoId = $(this).data("id");
    // フォーム作成
    let form = new FormData();
    form.append("_token", token);
    form.append("photo", photoId);
    // Ajax(POST)
    $.ajax({
      url: "/business/photo/" + photoId + "/cart/remove",
      type: "POST",
      data: form,
      processData: false,
      contentType: false,
    })
      .done(function (data) {
        // OK
        if (data) {
          // 成功
          buttonCart.html("リストに追加");
          buttonCart.addClass("add-photo-cart");
          buttonCart.removeClass("remove-photo-cart");
        } else {
          // 失敗
          console.log("リストの削除に失敗しました。");
          return;
        }
      })
      .fail(function (data) {
        // エラー
        return;
      });
  });
});
